import { Product } from '@inter-ikea-storageone/range';
import * as R from 'ramda';

/**
 * Sort products in clusters by decending height
 */
export const sortNestedClusterProductsByHeight = (clusters: Product[][]) => {
  return clusters.map(c => {
    return R.sortWith([R.descend(R.path(['communicatedDimensions', 'height']))])(c);
  });
};
